export default __webpack_public_path__ + "static/media/numpy-low-res.bdcac1b1.svg";